type Config = {
    Backend: {
        Host: string,
    }
}

const getConfig = async () => {
  return await (await fetch(`${process.env.PUBLIC_URL}/config.json`)).json() as Config;
};

export default getConfig;
